import React, { Component } from 'react';
import { search } from '../../_actions/form.actions';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { history } from '../../_helpers/history';

import moment from 'moment';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';

import SentActions from '../Forms/List/Components/SentActions';
import StatusPopover from '../Forms/List/Components/StatusPopover';
import CanceledActions from '../Forms/List/Components/CanceledActions';
import ScheduledActions from '../Forms/List/Components/ScheduledActions';
import CompletedActions from '../Forms/List/Components/CompletedActions';
import SearchComponent from './Components/SearchComponent';
import TodaysFormsEmpty from './Components/TodaysFormsEmpty';

class TodaysFormsTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      initLoad: true
    }

    this.loadData = this.loadData.bind(this);
    this.searchParams = this.searchParams.bind(this)
  }

  componentDidMount() {
    if (this.props.currentUser.UserType.Name === 'Licensed') {
      const providerId = this.props.currentUser.Doctor.DoctorId;

      history.push(`/dashboard/forms?professional=${providerId}&time=${Date.now()}`)
    } else {
      this.loadData();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      if (this.state.initLoad && this.props.collection.length > 0) {
        this.setState({ initLoad: false })
      }
      this.loadData();
    }
  }

  loadData() {
    const searchParams = this.searchParams();
    this.props.dispatch(search(searchParams));
  }

  searchParams() {
    const queryParams = queryString.parse(this.props.location.search);
    const showDateRange = ("completeByStartDate" in queryParams) ? true : false;

    return {
      page: queryParams.page || 1,
      firstName: queryParams.firstName || '',
      lastName: queryParams.lastName || '',
      dateOfBirth: queryParams.dateOfBirth || '',
      completeByDate: moment().local().format('MM/DD/YYYY'),
      completeByStartDate: showDateRange ? queryParams.completeByStartDate || '' : '',
      completeByEndDate: showDateRange ? queryParams.completeByEndDate || '' : '',
      groupId: queryParams.location ? parseInt(queryParams.location) : '',
      providerId: queryParams.professional ? parseInt(queryParams.professional) : '',
      status: queryParams.status || '',
      form: queryParams.form ? parseInt(queryParams.form) : '',
    }
  }

  render() {
    const columns = [
      {
        name: <StatusPopover />,
        width: '95px',
        sort: false,
        cell: form => <span className='badge badge-info text-uppercase'>{form.status}</span>
      },
      {
        name: 'First Name',
        sort: false,
        style: { paddingRight: '5px' },
        cell: row => {
          if (row.userProfile) {
            return `${row.userProfile.firstName}`
          } else {
            return `${row.patientFirstName}`
          }
        }
      },
      {
        name: 'Last Name',
        sort: false,
        style: { paddingRight: '5px' },
        cell: row => {
          if (row.userProfile) {
            return `${row.userProfile.lastName}`
          } else {
            return `${row.patientLastName}`
          }
        }
      },
      {
        name: 'Complete By',
        sort: false,
        cell: row => {
          return <>
            {moment.tz(row.completeByDate.date, row.completeByDate.timezone).local().format('l LT')}
          </>
        }
      },
      {
        name: 'Provider',
        sort: false,
        cell: row => {
          return `${row.doctor.firstName} ${row.doctor.lastName}`
        }
      },
      {
        name: 'Location',
        sort: false,
        cell: row => {
          return row.providerGroup.name
        }
      },
      {
        name: 'Form',
        grow: 2,
        sort: false,
        style: { paddingRight: '5px' },
        cell: form => {
          return form.questionnaire.title
        }
      },
      {
        sort: false,
        grow: 3,
        style: { justifyContent: "left", paddingRight: 0, paddingLeft: 0 },
        cell: (form) => {
          if (form.status === 'SCHEDULED') {
            return <ScheduledActions form={form} />
          }
          if (form.status === 'SENT') {
            return <SentActions loadData={this.loadData} form={form} />
          }
          if (form.status === 'COMPLETED') {
            return <CompletedActions form={form} />
          }
          if (form.status === 'CANCELED') {
            return <CanceledActions form={form} />
          }
        }
      }
    ];

    const { isSearching, collection, total } = this.props;

    const urlParams = this.searchParams();

    if (this.state.initLoad && isSearching) {
      return <Spinner animation="border" role="status" />
    }

    else if (this.state.initLoad && collection.length === 0) {
      return <TodaysFormsEmpty />
    }

    else {
      return <div className="row">
        <div className="col-lg-12 pr-0">
          <DataTable
            title="Today's Forms"
            subHeader
            overflowY
            subHeaderComponent={
              <SearchComponent
                location={this.props.location}
                handleClear={() => history.push('/dashboard/forms')}
                handleSearch={(params) => {
                  const { firstName, lastName, locationId, professional } = params;
                  history.replace(`/dashboard/forms?firstName=${firstName}&lastName=${lastName}&location=${locationId}&professional=${professional}`)
                }} />
            }
            columns={columns}
            data={collection}
            progressPending={isSearching}
            onChangePage={page => {
              const queryParams = queryString.parse(this.props.location.search);

              const lastName = queryParams.lastName || '';
              const location = queryParams.location ? parseInt(queryParams.location) : '';
              const firstName = queryParams.firstName || '';
              const dateOfBirth = queryParams.dateOfBirth || '';
              const professional = queryParams.professional ? parseInt(queryParams.professional) : '';
              const completeByDate = moment().local().format('MM/DD/YYYY');

              history.replace(`/dashboard/forms?page=${page}&firstName=${firstName}&lastName=${lastName}&dateOfBirth=${dateOfBirth}&completeByDate=${completeByDate}&location=${location}&professional=${professional}`)
            }}
            striped={true}
            pagination={true}
            paginationServer={true}
            paginationTotalRows={total}
            paginationRowsPerPageOptions={[15]}
            paginationPerPage={15}
            paginationDefaultPage={parseInt(urlParams.page)}
            noDataComponent={<div className="p-4">We could not find any results based on your search criteria</div>}
            customStyles={{ subHeader: { style: { padding: '0px' }, }, cells: { style: { fontSize: '14px', paddingTop: '.5em', paddingBottom: '.5em' }, }, }}
          />
        </div>
      </div>
    }

  }
}

function mapStateToProps(state) {
  return {
    total: state.form.collection.collection ? state.form.collection.total : 0,
    collection: state.form.collection.collection ? state.form.collection.collection.data : [],
    currentUser: state.user.currentUser,
    isSearching: state.form.isSearching
  };
}

export default connect(mapStateToProps)(TodaysFormsTable);